import EventEmitter from 'events'

const errorEmitter = new EventEmitter()

export const notifyErrorBoundary = (error: Error) => {
  errorEmitter.emit('error', error)
}

export const clearErrorBoundary = () => {
  errorEmitter.emit('clear-error')
}

export const errorEventEmitter = errorEmitter
